import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-xl-10 mx-auto mb-10" }
const _hoisted_4 = { class: "fw-bold d-flex align-items-center text-dark" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Reviewing   ")
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("'s KYC Information ")
const _hoisted_8 = { class: "col-12 col-xl-10 mx-auto" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_KYCForm = _resolveComponent("KYCForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.loadingKYCs)
          ? (_openBlock(), _createBlock(_component_PageTitle, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.applicant?.fullname), 1),
                  _hoisted_7
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_KYCForm, {
              kyc: _ctx.kyc,
              loading: _ctx.loadingKYCs
            }, null, 8, ["kyc", "loading"])
          ])
        ])
      ])
    ])
  ]))
}